import { useQuery } from '@tanstack/react-query'
import { getMedChangeLog } from '../../../../apis/medChangeLog'
import { queryKeys } from '../../../../shared'

/**
 * 薬剤変更ログ一覧を取得する Query hook
 */
export const useMedChangeLogsQuery = () => {
  return useQuery({
    queryKey: queryKeys.medChangeLogs.list(),
    queryFn: async () => {
      const { data } = await getMedChangeLog()
      return data
    },
  })
}
